import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD7dWWkti-w2mDWYjvKocF_MD0qjT4R_RM",
  authDomain: "streamamine.firebaseapp.com",
  projectId: "streamamine",
  storageBucket: "streamamine.firebasestorage.app",
  messagingSenderId: "797885566669",
  appId: "1:797885566669:web:021e930882eebf767b2384",
  measurementId: "G-H72M1L0WWP"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  })
});
